// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_0-badge {
  /* Typography */
  --perxis-auto-badge-font-family-inner: var(
    --perxis-auto-badge-font-family,
    var(--perxis-auto-root-typography-marker-font-family-inner)
  );
  --perxis-auto-badge-font-size-inner: var(
    --perxis-auto-badge-font-size,
    var(--perxis-auto-root-typography-marker-font-size-xxl-inner)
  );
  --perxis-auto-badge-font-weight-inner: var(
    --perxis-auto-badge-font-weight,
    var(--perxis-auto-root-typography-marker-font-weight-inner)
  );
  --perxis-auto-badge-font-variant-numeric-inner: var(
    --perxis-auto-badge-font-variant-numeric,
    var(--perxis-auto-root-typography-marker-font-variant-numeric-inner)
  );
  --perxis-auto-badge-letter-spacing-inner: var(--perxis-auto-badge-letter-spacing, 0);
  --perxis-auto-badge-line-height-inner: var(--perxis-auto-badge-line-height, 1);
  --perxis-auto-badge-text-transform-inner: var(--perxis-auto-badge-text-transform, none);
  /* End Typography */
  /* Colors */
  --perxis-auto-badge-background-color-inner: var(--perxis-auto-badge-background-color-current);
  --perxis-auto-badge-border-color-inner: var(--perxis-auto-badge-border-color-current);
  --perxis-auto-badge-color-inner: var(--perxis-auto-badge-color-current);
  /* End Colors */
  /* Primary */
  --perxis-auto-badge-primary-background-color-inner: var(
    --perxis-auto-badge-primary-background-color,
    var(--perxis-auto-root-seventh-color-inner)
  );
  --perxis-auto-badge-primary-border-color-inner: var(
    --perxis-auto-badge-primary-border-color,
    var(--perxis-auto-root-seventh-color-inner)
  );
  --perxis-auto-badge-primary-color-inner: var(
    --perxis-auto-badge-primary-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Primary */
  /* Secondary */
  --perxis-auto-badge-secondary-background-color-inner: var(
    --perxis-auto-badge-secondary-background-color,
    var(--perxis-auto-root-eighth-color-inner)
  );
  --perxis-auto-badge-secondary-border-color-inner: var(
    --perxis-auto-badge-secondary-border-color,
    var(--perxis-auto-root-eighth-color-inner)
  );
  --perxis-auto-badge-secondary-color-inner: var(
    --perxis-auto-badge-secondary-color,
    var(--perxis-auto-root-typography-color-lightest-inner)
  );
  /* End secondary */
  /* Ghost */
  --perxis-auto-badge-ghost-background-color-inner: var(--perxis-auto-badge-ghost-background-color, transparent);
  --perxis-auto-badge-ghost-border-color-inner: var(
    --perxis-auto-badge-ghost-border-color,
    var(--perxis-auto-root-sixth-color-inner)
  );
  --perxis-auto-badge-ghost-color-inner: var(
    --perxis-auto-badge-ghost-color,
    var(--perxis-auto-root-typography-color-dark-inner)
  );
  /* End Ghost */
  /* Border */
  --perxis-auto-badge-border-radius-inner: var(--perxis-auto-badge-border-radius, 4px);
  --perxis-auto-badge-border-width-inner: var(--perxis-auto-badge-border-width, 1px);
  /* End Border */
  /* Box Shadow */
  --perxis-auto-badge-box-shadow-inner: var(--perxis-auto-badge-box-shadow, none);
  /* End Box Shadow */
  /* Padding */
  --perxis-auto-badge-padding-inner: var(--perxis-auto-badge-padding, 4px);
  /* End Padding */
  /* Sizes */
  --perxis-auto-badge-height-inner: var(--perxis-auto-badge-height, auto);
  --perxis-auto-badge-min-width-inner: var(--perxis-auto-badge-min-width, 15px);
  /* End Sizes */
}
.perxis-auto-1_16_0-badge.perxis-auto-1_16_0-badge-primary {
  --perxis-auto-badge-background-color-current: var(--perxis-auto-badge-primary-background-color-inner);
  --perxis-auto-badge-border-color-current: var(--perxis-auto-badge-primary-border-color-inner);
  --perxis-auto-badge-color-current: var(--perxis-auto-badge-primary-color-inner);
}
.perxis-auto-1_16_0-badge.perxis-auto-1_16_0-badge-secondary {
  --perxis-auto-badge-background-color-current: var(--perxis-auto-badge-secondary-background-color-inner);
  --perxis-auto-badge-border-color-current: var(--perxis-auto-badge-secondary-border-color-inner);
  --perxis-auto-badge-color-current: var(--perxis-auto-badge-secondary-color-inner);
}
.perxis-auto-1_16_0-badge.perxis-auto-1_16_0-badge-ghost {
  --perxis-auto-badge-background-color-current: var(--perxis-auto-badge-ghost-background-color-inner);
  --perxis-auto-badge-border-color-current: var(--perxis-auto-badge-ghost-border-color-inner);
  --perxis-auto-badge-color-current: var(--perxis-auto-badge-ghost-color-inner);
}
.perxis-auto-1_16_0-badge.ant-5_17_0-badge {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.perxis-auto-1_16_0-badge.ant-5_17_0-badge,
.perxis-auto-1_16_0-badge.ant-5_17_0-badge .ant-5_17_0-badge-count {
  font-family: var(--perxis-auto-badge-font-family-inner);
  font-size: var(--perxis-auto-badge-font-size-inner);
  font-weight: var(--perxis-auto-badge-font-weight-inner);
  letter-spacing: var(--perxis-auto-badge-letter-spacing-inner);
  line-height: var(--perxis-auto-badge-line-height-inner);
  text-transform: var(--perxis-auto-badge-text-transform-inner);
  font-variant-numeric: var(--perxis-auto-badge-font-variant-numeric-inner);
  color: var(--perxis-auto-badge-color-current);
  user-select: none;
}
.perxis-auto-1_16_0-badge.ant-5_17_0-badge .ant-5_17_0-badge-count {
  padding: var(--perxis-auto-badge-padding-inner);
  border-style: solid;
  border-radius: var(--perxis-auto-badge-border-radius-inner);
  border-width: var(--perxis-auto-badge-border-width-inner);
  box-shadow: var(--perxis-auto-badge-box-shadow-inner);
  background-color: var(--perxis-auto-badge-background-color-current);
  border-color: var(--perxis-auto-badge-border-color-current);
  height: var(--perxis-auto-badge-height-inner);
  min-width: var(--perxis-auto-badge-min-width-inner);
  transition: background-color 0.3s linear, border-color 0.3s linear, color 0.3s linear;
}
.perxis-auto-1_16_0-badge.ant-5_17_0-badge .ant-5_17_0-scroll-number .ant-5_17_0-scroll-number-only {
  height: var(--perxis-auto-badge-height-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
